<div class="spline-wrapper locked">

    <canvas #splineCanvas id="splineCanvas"></canvas>

    <!--<spline-viewer [url]="view.path" loading="eager" logo="no" [background]="view.backgroundColor"></spline-viewer>-->

</div>